import { environment } from '../../../environments/environment';

const apiUrl = environment.apiUrl || '/nebula';

export function makeUrl(route: string) {
  const prefix = route.startsWith('/') ? '' : '/';
  return apiUrl + prefix + route;
}
